
import { Component, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { MsgItem } from '@/const/notification'

@Component({
	name: 'ReminderBanner',
})
export default class ReminderBanner extends Vue {
  @State((state: any) => state.notification.bannerList) bannerList: MsgItem[]
	onGoReminder() {
		this.$router.push({ name: 'notification-reminders' })
	}
}
